import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';

import Autocomplete from '@material-ui/lab/Autocomplete';

import {Loading} from '../../../components/Loading/Loading'

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog';
import { getTodayDateString, parsePlainDate, toPlainDateString } from '../../../utils/DateUtils';

const CLOSE = gql`
    mutation(
        $id: String!,
        $closedAt: Date!,
        $closeReason: String!,
    ){
        bayphoneClose(
            id:$id, 
            closedAt: $closedAt,
            closeReason: $closeReason,
        ) {
            bayphone {
                id
            }
        }
    }
`;

const CLOSE_REASONS = gql`
    query {
        allBayphoneCloseReasons {
            id
            name
        }
    }
`;

const BayphoneCloseDialog = props => {
    const [ isLoading, setLoading ] = useState(false);
    const [ closeReason, setCloseReason ] = useState(null);
  const [closedAt, setClosedAt] = useState(getTodayDateString());

    const { open, handleClose, selectedRows, t } = props;

    const dispatch = useDispatch()
    const client = useApolloClient()

    useEffect(() => {
        return () => {
            setLoading(false);
            setCloseReason(null);
      setClosedAt(getTodayDateString());
        };
    }, []);

    const onClickProcess = () => {
        setLoading(true)

        client.mutate({
            mutation: CLOSE,
            variables: {
                id: selectedRows[0].id,
                closedAt: closedAt,
                closeReason: closeReason.value,
            },
        })
        .then(result => {
            const success = result.data;
            
            if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
                handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
            }
        })
        .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
            text: text, 
            duration: 8000,
            variant: variant,
        }))
    }

    const handleQueryExecuted  = (success, message) => {
        createApplicationMessage(message, success ? 'success' : 'error');
        setLoading(false);
        onCloseDialog();
    }

    const onCloseDialog = () => {
        setCloseReason(null);
        handleClose();
    }

    const submitable = () => {
        return (closeReason && closedAt) && (isLoading === false)
    }

  const handleClosedAtChange = date => {
    setClosedAt(toPlainDateString(date) || '');
  };

  const closedAtDate = closedAt ? parsePlainDate(closedAt) : null;

    return (
        <Loading query={CLOSE_REASONS} showLoading={false}>
            {(data) => {
                return (
                    <BPMDialog 
                    open={open} 
                    onClose={onCloseDialog}
                    maxWidth='md'
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                    >
                        <DialogTitle id='alert-dialog-title'>
                            <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
                            {t('bayphone: Bayphone')}
                        </DialogTitle>
                        <DialogContent>
                            <Autocomplete
                                options={data.allBayphoneCloseReasons.map(item => ({label: item.name, value: item.id}))}
                                getOptionLabel={(option) => option.label || ''}
                                getOptionSelected={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => { setCloseReason(newValue) }}
                                value={closeReason}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label={t('bayphone:Close reason')}
                                    variant='outlined'
                                    style={{ marginBottom: 15 }}
                                    />
                                )}
                            />
              <DatePicker
                            label={t('bayphone:Closed at')}
                value={closedAtDate}
                onChange={handleClosedAtChange}
                inputVariant='outlined'
                format='P'
                style={{ width: 250, marginTop: 10, marginBottom: 10 }}
                            />
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'space-between' }}>
                            <div>
                                <Button 
                                    style={{ marginRight: 20 }}
                                    onClick={onCloseDialog} 
                                    variant='contained'
                                    disabled={isLoading}
                                >
                                    {t('bayphone:Cancel')}
                                </Button>
                                <Button
                                    onClick={onClickProcess}
                                    variant='contained'
                                    color='primary'
                                    disabled={!submitable()}
                                >
                                    {t('bayphone:Close')}
                                </Button>
                            </div>
                        </DialogActions>
                    </BPMDialog>
                )
            }}
        </Loading>
    )
};

export default BayphoneCloseDialog;
